import {
  createTriggerOnEnter,
  SUB_SECTION_REVEAL_START,
} from "./reveal-on-enter.js";

export function initSubPageInteractions(_opts = {}) {
  initPorcessReveal();
  initServiceProcessTimeline();
}

function initPorcessReveal() {
  const sections = document.querySelectorAll(".porcess-cont");
  if (!sections.length) return;

  const prefersReduced = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  sections.forEach((section) => {
    if (prefersReduced) {
      section.classList.add("is-revealed");
      return;
    }

    createTriggerOnEnter({
      trigger: section,
      start: SUB_SECTION_REVEAL_START,
      onEnter: () => section.classList.add("is-revealed"),
    });
  });
}

function initServiceProcessTimeline() {
  const timeline = document.querySelector(".service-process__timeline");
  if (!timeline) return;

  const fill = timeline.querySelector(".service-process__fill");
  const steps = Array.from(timeline.querySelectorAll(".service-process__step"));
  if (!steps.length) return;

  const prefersReduced = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  if (prefersReduced) {
    steps.forEach((step) => step.classList.add("is-active"));
    if (fill) fill.style.width = "100%";
    return;
  }

  const TOTAL = 2.0;
  const STAGGER = TOTAL / (steps.length - 1);
  const isMobile = () => window.matchMedia("(max-width: 768px)").matches;

  createTriggerOnEnter({
    trigger: timeline,
    start: "top 72%",
    onEnter: () => {
      if (!isMobile() && fill) {
        gsap.to(fill, {
          width: "100%",
          duration: TOTAL,
          ease: "power2.inOut",
        });
      }
      steps.forEach((step, i) => {
        gsap.delayedCall(i * STAGGER * 0.9, () =>
          step.classList.add("is-active"),
        );
      });
    },
  });
}
